export default __webpack_public_path__ + "static/media/BB_16.eee1ba75.png";